import React, {Component} from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import {login, resetPassword, clearResult, clearLoginResult, validateToken,requestPwEmail} from '../action/userActions'
import '../../css/ewLogin.css'
import {Button, Form, Card, Col, Modal, Row, Alert} from 'react-bootstrap'


class SelectPwFunction extends Component {
    constructor(props){
        super(props)
      
        this.state = {userName  : ''}
    }

    render(){
        return  <Form hidden={this.props.loading} style={{margin : '10px'}}>
                 <h3>Password</h3>

                <Form.Row style={{marginTop : '40px'}}>
                    <Form.Group as={Col} controlId="formGridEmail">
                        <Button className='loginBtn' style={{backgroundColor : '#015daa'}} onClick={()=>{
              //    window.location = '/custom/changepassword?mode=reset'
                  this.props.history.push('/changepassword?mode=reset')

                        }}>
                            Change Password
                        </Button>
                      </Form.Group>

                      <Form.Group as={Col} controlId="formGridEmail">
                        <Button className='loginBtn' style={{backgroundColor : '#015daa'}} onClick={()=>{
                        //    window.location = '/custom/changepassword?mode=request'
                        this.props.history.push('/changepassword?mode=request')

                        }}>
                            Forgot Password
                        </Button>
                      </Form.Group>

                </Form.Row>
                        
        </Form>
    }
}

const mapStateToProps = state =>({
    user : state.acct.user.loggedInUser,
    loading : state.acct.user.loading,
})

export default withRouter(connect(mapStateToProps)(SelectPwFunction))